import React, { FC } from 'react';

import SideNavigation from '@adsk/alloy-side-navigation';

import RemoteSideNavigationCollapsedError from './RemoteSideNavigationCollapsedError';
import RemoteSideNavigationExpandedError from './RemoteSideNavigationExpandedError';

const RemoteSideNavigationError: FC = () => {
  return (
    <SideNavigation
      topItems={[{ key: 'error-item' }]}
      style={{
        maxWidth: 220,
      }}
      renderItem={({ collapsed, item }) => {
        if (collapsed) {
          return <RemoteSideNavigationCollapsedError key={item.key} />;
        }
        return <RemoteSideNavigationExpandedError key={item.key} />;
      }}
    />
  );
};

export default RemoteSideNavigationError;
